module.exports = __webpack_public_path__ + "static/media/DelivaHere Promo Pricing Guide.8369ccf7.pdf";